class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setupTermsDedup();
    this.setupLayoutStyle();
    this.setupInstantOpen();
  }

  // Matted : la case CGV du panier latéral (#CartDrawer-Terms) bloque la commande.
  // La case ajoutée par l'appli de CGV est masquée dans le panier latéral pour éviter le doublon,
  // et synchronisée avec la nôtre.
  setupTermsDedup() {
    if (!document.getElementById('mq-cd-terms-style')) {
      const st = document.createElement('style');
      st.id = 'mq-cd-terms-style';
      st.textContent = '#CartDrawer .terms-relentless{display:none !important}';
      document.head.appendChild(st);
    }
    document.addEventListener('change', (e) => {
      if (!e.target || e.target.id !== 'CartDrawer-Terms') return;
      document.querySelectorAll('#CartDrawer .rterms-checkbox').forEach((c) => {
        if (c.checked !== e.target.checked) {
          c.checked = e.target.checked;
          c.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // Matted : mise en page du panier latéral (marge, titre lisible, responsive)
  // et état « ajout en cours » affiché dès le clic.
  setupLayoutStyle() {
    if (document.getElementById('mq-cd-layout-style')) return;
    const st = document.createElement('style');
    st.id = 'mq-cd-layout-style';
    st.textContent = `
cart-drawer,cart-drawer.drawer{width:100%;left:0;right:0}
cart-drawer .drawer__inner{width:46rem;max-width:100%;padding:0 2.4rem;box-sizing:border-box}
cart-drawer .drawer__header{padding:2rem 0 1.2rem;gap:1.2rem}
cart-drawer .drawer__heading{margin:0;font-size:2.4rem;line-height:1.2;font-weight:700;letter-spacing:0}
cart-drawer .drawer__header .drawer__close{position:static;flex:none;margin-right:-1rem;display:inline-flex;align-items:center;justify-content:center}
cart-drawer .drawer__close .svg-wrapper{width:2.2rem;height:2.2rem}
cart-drawer .cart-drawer .cart-item__totals{padding-right:.4rem}
cart-drawer.mq-pending .drawer__inner{position:relative}
cart-drawer.mq-pending .drawer__inner>*:not(.drawer__header){visibility:hidden}
cart-drawer.mq-pending.is-empty .drawer__inner>*{visibility:hidden}
cart-drawer.mq-pending .drawer__inner::before{content:"";position:absolute;left:50%;top:42%;width:3.6rem;height:3.6rem;margin:-1.8rem 0 0 -1.8rem;border:.3rem solid #cfe3e6;border-top-color:#015560;border-radius:50%;animation:mq-cd-spin .8s linear infinite}
cart-drawer.mq-pending .drawer__inner::after{content:"Ajout au panier…";position:absolute;left:0;right:0;top:calc(42% + 3rem);text-align:center;font-size:1.6rem;font-weight:600;color:#015560}
@keyframes mq-cd-spin{to{transform:rotate(360deg)}}
html.mq-cd-open shopify-chat{display:none!important}
@media screen and (max-width:989px){cart-drawer .drawer__inner{width:42rem;padding:0 2rem}}
@media screen and (max-width:749px){
cart-drawer .drawer__inner{width:100%;padding:0 1.6rem}
cart-drawer .drawer__heading{font-size:2.1rem}
cart-drawer .drawer__header{padding:1.6rem 0 1rem}
}
@media (prefers-reduced-motion:reduce){cart-drawer.mq-pending .drawer__inner::before{animation-duration:2s}}
`;
    document.head.appendChild(st);
  }

  // Matted : le panier latéral s'ouvre dès le clic sur « Ajouter au panier »,
  // avec un indicateur d'ajout, puis se remplit quand la boutique répond.
  setupInstantOpen() {
    if (window.__mqCdInstant) return;
    window.__mqCdInstant = true;
    const drawer = this;
    const isAddUrl = (u) => typeof u === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(u.split('#')[0].replace(location.origin, ''));

    const origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      const p = origFetch(input, init);
      if (drawer.pending && isAddUrl(url)) {
        drawer.pendingFetch = true;
        p.then(
          (res) => {
            if (!drawer.pending) return;
            if (!res.ok) return drawer.cancelPending();
            // Si le script appelant ne remplit pas le panier latéral, on le fait nous-mêmes.
            clearTimeout(drawer.pendingFallback);
            drawer.pendingFallback = setTimeout(() => drawer.refreshFromServer(), 2500);
          },
          () => drawer.cancelPending()
        );
      }
      return p;
    };

    const start = (btn) => {
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      drawer.showPending(btn);
    };
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest && e.target.closest('.tile-add-btn');
        if (btn) start(btn);
      },
      true
    );
    document.addEventListener(
      'submit',
      (e) => {
        const form = e.target;
        if (!form || !form.closest || !form.closest('product-form')) return;
        if (form.closest('quick-add-modal')) return;
        start(form.querySelector('[type="submit"]'));
      },
      true
    );
  }

  showPending(triggeredBy) {
    this.pending = true;
    this.pendingFetch = false;
    this.classList.add('mq-pending');
    document.documentElement.classList.add('mq-cd-open');
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    clearTimeout(this.pendingGuard);
    clearTimeout(this.pendingFallback);
    // Aucun envoi lancé (ex. option non choisie) : on referme aussitôt.
    this.pendingGuard = setTimeout(() => {
      if (this.pending && !this.pendingFetch) this.cancelPending();
    }, 600);
    // Filet de sécurité
    this.pendingMax = setTimeout(() => this.pending && this.refreshFromServer(), 12000);
  }

  clearPending() {
    this.pending = false;
    this.classList.remove('mq-pending');
    clearTimeout(this.pendingGuard);
    clearTimeout(this.pendingFallback);
    clearTimeout(this.pendingMax);
  }

  cancelPending() {
    if (!this.pending) return;
    this.clearPending();
    this.close();
  }

  refreshFromServer() {
    if (!this.pending) return;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((sections) => {
        if (!this.pending) return;
        this.renderContents({ sections });
      })
      .catch(() => this.cancelPending());
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
    // Matted : la bulle de discussion masque le bas du panier, on la cache tant qu'il est ouvert
    document.documentElement.classList.add('mq-cd-open');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.clearPending();
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('mq-cd-open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Matted : un ajout rend le panier non vide, quel que soit le script appelant
    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const wasPending = this.pending;
    this.clearPending();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (wasPending && this.classList.contains('active')) {
        // Déjà ouvert pendant l'ajout : on place le focus dans le panier
        const container = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (container && typeof trapFocus === 'function') trapFocus(container, focusElement);
        this.querySelector('cart-drawer-items')?.dispatchViewEvent?.();
      } else {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
